import { NavLink } from 'react-router-dom';
import { MenuItem as MenuItemMui } from '@mui/base/MenuItem';
import { TrialFlag } from 'core/components/TrialFlag';
import { MenuItem as IMenuItem } from '../../../NavBar';
import styles from './styles.scss';

interface MenuItemProps {
  menuItem: IMenuItem;
}

export const MenuItem = ({ menuItem }: MenuItemProps): JSX.Element => {
  const { to, title, isTrial, expirationDate } = menuItem;

  return (
    <MenuItemMui>
      <NavLink
        to={to}
        className={styles.link}
        activeClassName={styles.activeLink}
      >
        {title}
      </NavLink>

      {isTrial && <TrialFlag expirationDate={expirationDate} />}
    </MenuItemMui>
  );
};
